import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { SummaryValue } from "../../ui/SummaryValue";
import Paper from "@mui/material/Paper";
import LinearProgress from "@mui/material/LinearProgress";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Chip from "@mui/material/Chip";
import type { ValidatedProxyEntry, ProxyValidationSummary } from "./useProxyImport";
import { proxyStatusColor } from "./ProxyStatusColor";

interface ProxyImportResultsProps {
  entries: ValidatedProxyEntry[];
  summary: ProxyValidationSummary | null;
  isValidating: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ProxyImportResults(props: ProxyImportResultsProps) {
  const { entries, summary, isValidating, onConfirm, onCancel } = props;

  // Пока записи идут, полоса неопределённая; до первой записи — пустая, после
  // сводки — полная.
  const runningProgressValue = entries.length > 0 ? undefined : 0;
  const progressValue = summary !== null ? 100 : runningProgressValue;

  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        {isValidating ? "Проверка прокси…" : "Результаты проверки"}
      </Typography>

      <LinearProgress
        variant={progressValue === undefined ? "indeterminate" : "determinate"}
        value={progressValue}
        sx={{ mb: 2 }}
      />

      {summary !== null && (
        <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
          <Box display="flex" gap={3} flexWrap="wrap">
            <SummaryValue label="Всего" value={String(summary.totalCount)} />
            <SummaryValue label="Активных" value={String(summary.activeCount)} />
            <SummaryValue label="Неактивных" value={String(summary.inactiveCount)} />
            <SummaryValue label="Дубликатов" value={String(summary.duplicateCount)} />
            <SummaryValue label="Ошибок парсинга" value={String(summary.parseErrorCount)} />
          </Box>
        </Paper>
      )}

      <TableContainer component={Paper} variant="outlined" sx={{ mb: 2, maxHeight: 400 }}>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>Host</TableCell>
              <TableCell>Port</TableCell>
              <TableCell>Статус</TableCell>
              <TableCell>Ошибка</TableCell>
              <TableCell>Дубликат</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {entries.map((entry, index) => (
              <TableRow key={index}>
                <TableCell>{entry.host}</TableCell>
                <TableCell>{entry.port}</TableCell>
                <TableCell>
                  <Chip label={entry.status} color={proxyStatusColor(entry.status)} size="small" />
                </TableCell>
                <TableCell>{entry.errorCode ?? "—"}</TableCell>
                <TableCell>{entry.isDuplicate ? "Да" : "—"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Box display="flex" gap={1}>
        {!isValidating && (
          <Button variant="contained" onClick={onConfirm}>
            Подтвердить импорт
          </Button>
        )}
        <Button variant="outlined" onClick={onCancel}>
          Отмена
        </Button>
      </Box>
    </Box>
  );
}
